import ChalkySticks from '@chalkysticks/sdk';
import Store from '@/Store';
import State from './State';

/**
 * Mutations are a synchronous way of modifying state. They are generally
 * called through Actions. It's best to think of them as setters.
 *
 * @see https://vuex.vuejs.org/guide/mutations.html
 *
 * @class Mutations
 * @package Store/Module/Authentication
 * @project ChalkySticks App
 */
const mutations = {
	/**
	 * @param State state
	 * @return void
	 */
	logout(state: typeof State): void {
		state.token = '';
		state.user = undefined;
	},

	/**
	 * @param State state
	 * @param string token
	 * @return void
	 */
	setToken(state: typeof State, token: string): void {
		state.token = token;
	},

	/**
	 * @param State state
	 * @param IUser user
	 * @return void
	 */
	setUser(state: typeof State, user: IUser): void {
		state.user = user;
	},

	/**
	 * @param State state
	 * @param IUser user
	 * @return void
	 */
	updateUser(state: typeof State, user: IUser): void {
		Object.assign(state.user, user);
	},
};

export default mutations;
